export default __webpack_public_path__ + "static/media/warningLBIcon.57543afc.svg";